import React from 'react'
import { useQuery } from '@apollo/client'
import {
  CURRENT_CENTER,
  CURRENT_USER,
  CurrentCenterResult,
  CurrentUserResult
} from 'pages/components/Security/queries'
import Loader, { LoaderContainer } from 'components/Loader'
import { Address, User } from 'globals/models/User'
import { displayErrors } from 'globals/graphql'

interface IProps {
  noCenter?: boolean,
  children: (currentUser: User, currentCenters: Address[]) => React.ReactNode
}

const Security = (props: IProps) => {
  const { noCenter, children } = props
  const currentUserQuery = useQuery<CurrentUserResult>(CURRENT_USER, displayErrors)
  const currentCenterQuery = useQuery<CurrentCenterResult>(CURRENT_CENTER, displayErrors)

  return (
    <>
      {(
        currentUserQuery.loading ||
        !currentUserQuery.data?.currentUser ||
        (!noCenter && (currentCenterQuery.loading ||
          !currentCenterQuery.data?.currentAddresses
        ))) ?
        <LoaderContainer>
          <Loader extend />
        </LoaderContainer> :
        children(currentUserQuery.data.currentUser, (currentCenterQuery?.data?.currentAddresses as Address[]))
      }
    </>
  )
}

export default Security
